import List from "@/components/list";
import router from "@/router";
const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  //考试学员名单
  function examUserList(exam) {
    router.push({
      path: "/examInfo/members",
      query: { id: exam.uuid, examType: exam.examType, status: exam.examStatus }
    });
  }
  const Deal = ({ props: { vo } }) => {
    const exam = vo.row;
    const dealConf = [
      ["icon-user-list", "考试学员名单", () => examUserList(exam), ""]
    ];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      label: "试卷名称",
      prop: "paperName",
      minWidth: "160"
    },
    {
      label: "发布状态",
      prop: "publishStatusName",
      minWidth: "120"
    },
    {
      label: "考试状态",
      prop: "examStatusName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "创建时间",
      prop: "createDate",
      minWidth: "120",
      showOverflowTooltip: true
    },

    {
      label: "操作",
      minWidth: "160",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
